import { useEffect, useState } from 'react';
import { metodosPagoService } from '../services/api';

// Caché a nivel de módulo (mismo patrón que useConfigNegocio): varias pantallas
// piden los métodos de pago casi al mismo tiempo, con esto solo se hace un GET.
let cache: any[] | null = null;
let promesa: Promise<any[]> | null = null;

function cargarMetodos() {
  if (cache) return Promise.resolve(cache);
  if (!promesa) {
    promesa = metodosPagoService.getAll()
      .then((r: any) => { cache = r.data; return cache!; })
      .catch(() => []);
  }
  return promesa;
}

/**
 * Métodos de pago dinámicos (tabla metodos_pago) con helpers de etiqueta y
 * color, para no repetir diccionarios hardcodeados (efectivo/tarjeta/...) en
 * cada pantalla — un método de pago nuevo (ej. "Mercado Pago QR") se ve bien
 * en todos lados automáticamente.
 */
export function useMetodosPago() {
  const [metodos, setMetodos] = useState<any[]>(cache || []);

  useEffect(() => {
    let vivo = true;
    cargarMetodos().then(m => { if (vivo) setMetodos(m); });
    return () => { vivo = false; };
  }, []);

  const label = (clave: string) => metodos.find(m => m.clave === clave)?.nombre || clave;
  const color = (clave: string) => metodos.find(m => m.clave === clave)?.color || '#6B7280';

  return { metodos, label, color };
}
